/**
 * Referral programme amounts — the single frontend source. Must match the
 * `referral_config` table (functions read that; these are for copy/UI only).
 */
export const REFERRAL_CONFIG = {
  /** Discount for the referred friend on their first purchase. */
  DISCOUNT_PERCENT: 40,
  /** Hours the discount stays available after clicking a referral link. */
  DISCOUNT_HOURS: 72,
  /** Credits for the referrer when the friend verifies email + completes a first analysis. */
  SIGNUP_COMPLETE_CREDITS: 20,
  /** Credits for the referrer when the friend makes a first purchase. */
  PURCHASE_CREDITS: 100,
  /** Max rewarded referrals per referrer per 30 days. */
  MONTHLY_CAP: 20,
} as const;

export const REFERRAL_COOKIE_NAME = 'eyecaptain_referral';
export const REFERRAL_DISCOUNT_COOKIE_NAME = 'eyecaptain_referral_discount';

/** Referral code stored by the `?ref=` landing, if still valid. */
export function getStoredReferralCode(): string | null {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${REFERRAL_COOKIE_NAME}=([^;]*)`));
    if (!m) return null;
    const data = JSON.parse(decodeURIComponent(m[1])) as { referrerCode?: string; expiresAt?: number };
    if (!data.referrerCode || (data.expiresAt && data.expiresAt < Date.now())) return null;
    return data.referrerCode;
  } catch { return null; }
}
